import API from '../modules/api'
const api = new API({ authStoreKey: 'blog' })
import Mustache from 'mustache'

const params = {
  type: null,
  pagination: null,
  limit: null,
  offset: 0
}

class Blog {

  constructor() {
    this.element = document.querySelector('.js-blog')
    this.list = document.querySelector('.js-blog-list')
    this.listItemTemplate = document.querySelector('.js-blog-list-item-template')
    this.loadMore = document.querySelector('.js-blog-load-more')
  }

  /**
   * Initialize blog
   */
  init() {
    if (this.element && this.list) {
      this.setupList()
      this.addListeners()
    }
  }

  /**
   * Setup blog list
   */
  setupList() {
    params.type = 'list'
    params.pagination = true
    params.limit = 4
    this.getData().then(data => {
      this.render(data)
    })
  }

  /**
   * Get data from API
   * @returns {object} result from API
   */
  getData() {
    return api.getBlogArticles(params)
  }

  /**
   * Use Mustache to render HTML
   * @param {object} result from API
   */
  render(result) {
    this.list.innerHTML += Mustache.render(this.listItemTemplate.innerHTML, result.data)
    if (result.data.pagination.hasMore) {
      this.loadMore.style.display = 'inline-block';
    }
  }

  /**
   * Add events to buttons (like load more)
   */
  addListeners() {
    if (this.loadMore) {
      this.loadMore.addEventListener('click', () => {
        params.offset = params.offset || 0 + params.limit
        this.loadMore.setAttribute('disabled', true)
        this.loadMore.querySelector('svg').style.display = 'inline-block';
        this.getData().then(data => {
          this.render(data)
          this.loadMore.removeAttribute('disabled')
          this.loadMore.style.display = 'none';
          this.loadMore.querySelector('svg').style.display = 'none';
        })
      })
    }
  }

}

const blog = new Blog()
export default blog
